import { deserialize, serializable } from 'serializr';
import { Base } from './base.model';
import { ArchivalPeriod } from '@modules/test-development/enums/archival-period.enum';
import { AccessibilityTestingType } from '@enums/accessibility-testing-type.enum';

export class Preference extends Base {
  @serializable
  public autoHealing: boolean;
  @serializable
  public manualTesting: boolean;
  @serializable
  public testCaseReviewManagement: boolean;
  @serializable
  public elementReviewManagement: boolean;
  @serializable
  public selfReviewManagement: boolean;
  @serializable
  public onBoardingPopup: boolean;
  @serializable
  public highlightElementEnabled: boolean;
  @serializable
  public controlExecutionStopAction: boolean;
  @serializable
  public apiMaxTimeout: number;
  @serializable
  public genai: boolean;
  @serializable
  public genaiRecorder: boolean;
  @serializable
  public genaiXrayDesign: boolean;
  @serializable
  public genaiFigma: boolean;
  @serializable
  public genaiSwaggerToApi: boolean;
  @serializable
  public genaiFiles: boolean;
  @serializable
  public genaiTdp: boolean;
  @serializable
  public maxRerunLimit: number;
  @serializable
  public assetsArchivalPeriod: ArchivalPeriod;
  @serializable
  public accessibilityTestingType: AccessibilityTestingType;
  @serializable
  public agenticAiAutomationMode: boolean;
  @serializable
  public agenticAiLearningMode: boolean;
  @serializable
  public agenticAiAnalyzeMode: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Preference, input));
  }
}
